/**
 * 接口请求api
*/

import * as _axios from "./request";

// 轮播图相关API

/**
 * [getBannerLists 获取首页轮播图列表]
 * @return {Promise} [description]
 */
export const getBannerLists = async ()=>{
  let url = `/web/banner/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getBannerLists");
    // data = e;
  }
  return data;
}

// 用户相关API

/**
 * [getMailVerifyCode 根据邮箱获取验证阿妈]
 * @param  {[type]} mail [邮箱内容]
 * @return {[type]}      [description]
 */
export const getMailVerifyCode = async ({
  mail
})=>{
  let url = `/web/custom/mail/code`;
  let params = {
    mail
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"getMailVerifyCode");
    data = e;
  }
  console.log("data====",data);
  return data;
}

/**
 * [createCustomer 创建用户]
 * @param  {[type]} realName   [姓名]
 * @param  {[type]} countryId  [国家ID]
 * @param  {[type]} provinceId [省份ID]
 * @param  {[type]} cityId     [城市ID]
 * @param  {[type]} account    [账号]
 * @param  {[type]} mail       [邮箱]
 * @param  {[type]} code       [验证码]
 * @param  {[type]} password   [密码]
 * @return {[type]}            [description]
 */
export const createCustomer = async ({
  realName,
  countryId,
  provinceId,
  cityId,
  account,
  mail,
  code,
  password
})=>{
  let url = `/web/custom/create`;
  let params = {
    realName,
    countryId,
    provinceId,
    cityId,
    account,
    mail,
    code,
    password
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"createCustomer");
    // data = e
  }
  return data;
}

/**
 * [customerDeleteAccount 用户注销账户]
 * @param  {String} [email=""] [邮箱]
 * @param  {String} [code=""}] [验证码]
 * @return {[type]}            [description]
 */
export const customerDeleteAccount = async ({
  email,
  code
})=>{
  let url = `/web/custom/delete/apply`;
  let params = {
    email,
    code
  };
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"customerDeleteAccount");
    // data = e;
  }
  return data;
}

/**
 * [getLoginUserInfo 获取登录用户信息]
 * @return {Promise} [description]
 */
export const getLoginUserInfo = async ()=>{
  let url = `/web/custom/info`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getLoginUserInfo");
    // data = e;
  }
  return data;
}

/**
 * [getUserInfoById 根据ID获取用户信息]
 * @param  {[type]}  id [用户ID]
 * @return {Promise}    [description]
 */
export const getUserInfoById = async ({
  id
})=>{
  let url = `/web/custom/${id}/info`;
  let params = {
    id
  };
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getUserInfoById");
    // data = e;
  }
  return data;
}


// 登录相关接口

/**
 * [emailLogin 邮箱登录]
 * @param  {[type]}  email    [邮箱]
 * @param  {[type]}  password [密码]
 * @return {Promise}          [description]
 */
export const emailLogin = async ({
  email,
  password
})=>{
  let url = `/web/account/email/login`;
  let params = {
    email,
    password
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"emailLogin");
    // data = e;
  }
  return data;
}

/**
 * [googleLogin 谷歌登录]
 * @param  {[type]}  openId          [description]
 * @param  {[type]}  email           [description]
 * @param  {String}  [nickName=""]   [description]
 * @param  {String}  [avatarUrl=""}] [description]
 * @return {Promise}                 [description]
 */
export const googleLogin = async ({
  openId,
  email,
  nickName = "",
  avatarUrl = ""
})=>{
  let url = `/web/account/google/login`;
  let params = {
    openId,
    email,
    nickName,
    avatarUrl
  };

  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"googleLogin");
    // data = e;
  }
  return data;
}

/**
 * [userLogout 用户登出]
 * @return {Promise} [description]
 */
export const userLogout = async ()=>{
  let url = `/web/account/logout`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"userLogout");
    // data = e;
  }
  return data;
}

// 作品相关API

/**
 * [createWorks 创建作品]
 * @param  {[type]}  param [参数]
 * "videos": [
    {
      "videoId": "",
      "videoName": "",
      "coverId": ""
    }
  ],
  "title": "",
  "intro": "",
  "coverId": "",
  "tagIds": [],
  "countryId": "",
  "provinceId": "",
  "cityId": "",
  "attachmentIds": [],
  "activityId": ""
 * @return {Promise}       [description]
 */
export const createWorks = async ({...param})=>{
  let url = `/web/works`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"createWorks");
    // data = e;
  }
  return data;
}

/**
 * [getWorksByPage 获取我的作品分页数据]
 * @param  {[type]}  customId    [用户ID]
 * @param  {[type]}  auditStatus [审核状态] AUDIT_WAIT AUDIT_REJECT AUDIT_PASS AUDIT_ACCEPT
 * @param  {[type]}  pageNum     [页码]
 * @param  {[type]}  pageSize    [每次请求的数据数]
 * @return {Promise}             [description]
 */
export const getWorksByPage = async ({
  customId,
  auditStatus,
  pageNum,
  pageSize
})=>{
  let url = `/web/works/page`;
  let params = {
    customId,
    pageNum,
    pageSize
  };
  if(auditStatus){
    params["auditStatus"] = auditStatus;
  }
  let data = {};
  try{
    data = await _axios.get({url, params})||{};
  }
  catch(e){
    console.error(e,"getWorksByPage");
    // data = e;
  }
  return data;
}

/**
 * [deleteWorks 删除作品]
 * @param  {[type]}  worksId [作品Id]
 * @return {Promise}         [description]
 */
export const deleteWorks = async ({
  worksId
})=>{
  let url = `/web/works/delete`;
  let params = {
    worksId
  }

  let data = {};
  try{
    data = await _axios.put({url, params, type: "query"})||{};
  }
  catch(e){
    console.error(e,"deleteWorks");
    // data = e;
  }
  return data;
}

/**
 * [getRecommendWorksByTag 根据tag获取相关作品]
 * @param  {[type]}  tagId    [标签ID]
 * @return {Promise}          [description]
 */
export const getRecommendWorksByTag = async ({
  tagId,
})=>{
  let url = `/web/works/tag/recommend/list`;
  let params = {
    tagId,
  };
  let data = {};
  try{
    data = await _axios.get({url, params})||{};
  }
  catch(e){
    console.error(e,"getRecommendWorksByTag");
    // data = e;
  }
  return data;
}

/**
 * [getWorksDetailById 通过ID获取作品详情]
 * @param  {[type]}  id [作品Id]
 * @return {Promise}    [description]
 */
export const getWorksDetailById = async ({
  id
})=>{
  let url = `/web/works/detail`;
  let params = {
    id
  };

  let data = {};
  try{
    data = await _axios.get({url, params})||{};
  }
  catch(e){
    console.error(e,"getWorksDetailById");
    // data = e;
  }
  return data;
}

/**
 * [updateWorks 更新作品]
 * @param  {[type]}  param [相应参数]
 * @return {Promise}       [description]
 */
export const updateWorks = async ({
  ...param
})=>{
  let url = `/web/works`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.put({url, params})||{};
  }
  catch(e){
    console.error(e,"updateWorks");
    // data = e;
  }
  return data;
}

// 草稿箱相关API

/**
 * [getDraftDetail 获取详情]
 * @return {Promise} [description]
 */
export const getDraftDetail = async ()=>{
  let url = `/web/draft`;

  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getDraftDetail");
    // data = e;
  }
  return data;
}

/**
 * [createNewDraft 创建新草稿]
 * @param  {[type]}  param [description]
 * @return {Promise}       [description]
 * {
 * "title": "",
  "intro": "",
  "coverId": "",
  "tagIds": [],
  "countryId": "",
  "provinceId": "",
  "cityId": "",
  "attachmentIds": [],
  "activityId": "",
  "videos": [
    {
      "videoId": "",
      "videoName": "",
      "coverId": ""
    }
  ]}
 */
export const createNewDraft = async ({
  ...param
})=>{
  let url = `/web/draft`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"createNewDraft");
    // data = e;
  }
  return data;
}

/**
 * [updateDraft 更新草稿]
 * @param  {[type]}  param [description]
 * {
  "title": "",
  "intro": "",
  "coverId": "",
  "tagIds": [],
  "countryId": "",
  "provinceId": "",
  "cityId": "",
  "attachmentIds": [],
  "activityId": "",
  "videos": [
    {
      "videoId": "",
      "videoName": "",
      "coverId": ""
    }
  ]
}
 * @return {Promise}       [description]
 */
export const updateDraft = async ({
  ...param
})=>{
  let url = `/web/draft`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.put({url, params})||{};
  }
  catch(e){
    console.error(e,"updateDraft");
    // data = e;
  }
  return data;
}

/**
 * [deleteDraft 删除草稿]
 * @return {Promise} [description]
 */
export const deleteDraft = async ()=>{
  let url = `/web/draft`;
  let data = {};
  try{
    data = await _axios.Delete({url})||{};
  }
  catch(e){
    console.error(e,"deleteDraft");
    // data = e;
  }
  return data;
}

// 标签相关API

/**
 * [getWorkTagLists 作品标签列表]
 * @return {Promise} [description]
 */
export const getWorkTagLists = async ()=>{
  let url = `/web/tag/works/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getWorkTagLists");
    // data = e;
  }
  return data;
}

/**
 * [getSelectWorkTagLists 获取作品标签下拉列表]
 * @return {Promise} [description]
 */
export const getSelectWorkTagLists = async ()=>{
  let url = `/web/tag/works/select/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getSelectWorkTagLists");
    // data = e;
  }
  return data;
}

/**
 * [getPersonalTagList 获取用户个人标签列表]
 * @return {Promise} [description]
 */
export const getPersonalTagList = async ()=>{
  let url = `/api/tag/personal/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getPersonalTagList");
    // data = e;
  }
  return data;
}

/**
 * [correctUserTags 修改用户标签]
 * @param  {[type]}  customId   [description]
 * @param  {Array}   [tags=[]}] [description] id数组
 * @return {Promise}            [description]
 */
export const correctUserTags = async ({
  customId,
	tags = []
})=>{
  let url = `/api/user/tags`;
	let params = {
		customId,
		tags
	};

	let data = {};
	try{
		data = await _axios.put({url, params})||{};
	}
	catch(e){
		console.error(e,"correctUserTags");
		// data = e;
	}
	return data;
}


// 地区相关API

/**
 * [getAreaCountries 根据语言种类获取国家数据]
 * @param  {[type]}  version [语言种类 zh或者en]
 * @return {Promise}         [description]
 */
export const getAreaCountries = async ({
  version
})=>{
  let url = `/api/area/countries`;
  let params = {
    version
  }
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getAreaCountries");
    // data = e;
  }
  return data;
}

/**
 * [getAreaProvinces description]
 * @param  {[type]}  version   [语言种类]
 * @param  {[type]}  countryId [国家ID]
 * @return {Promise}           [description]
 */
export const getAreaProvinces = async ({
  version,
  countryId
})=>{
  let url = `/api/area/provinces`;
  let params = {
    version,
    countryId
  }
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getAreaProvinces");
    // data = e;
  }
  return data;
}

/**
 * [getAreaCities 获取城市]
 * @param  {[type]}  version    [语言版本]
 * @param  {[type]}  provinceId [省份ID]
 * @return {Promise}            [description]
 */
export const getAreaCities = async ({
  version,
  provinceId
})=>{
  let url = `/api/area/cities`;
  let params = {
    version,
    provinceId
  }
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getAreaCities");
    // data = e;
  }
  return data;
}


// 拍客学院相关接口

/**
 * [getCollegeArticleByPage 获取拍客学院文章]
 * @param  {[type]}  pageNum  [页码]
 * @param  {[type]}  pageSize [每次请求的数据量]
 * @return {Promise}          [description]
 */
export const getCollegeArticleByPage = async ({
  pageNum,
  pageSize
})=>{
  let url = `/web/college/article/list`;
  let params = {
    pageNum,
    pageSize
  };
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getCollegeArticleByPage");
    // data = e;
  }
  return data;
}

/**
 * [getColleageArticleDetail 获取拍客学院文章详情]
 * @param  {[type]}  id [文章ID]
 * @return {Promise}    [description]
 */
export const getColleageArticleDetail = async ({
  id
})=>{
  let url = `/web/college/article/${id}`;
  let params = {
    id
  };
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getColleageArticleDetail");
    // data = e;
  }
  return data;
}


// 获取协议内容

/**
 * [getAgreementContent web获取APP协议内容]
 * @param  {[type]}  agreementType [协议类型]
 * PRIVACY 隐私协议,REGISTRATION 注册,RIGHTS_INTERESTS,COPYRIGHT_TRANSFER,PUBLISH_EVENTS
 * @return {Promise}               [description]
 */
export const getAgreementContent = async ({
  agreementType
})=>{
  let url = `/web/agreement/content`;
  let params = {
    agreementType
  }
  let data = {};
  try{
    data = await _axios.get({url,params})||{};
  }
  catch(e){
    console.error(e,"getAgreementContent");
    // data = e;
  }
  return data;
}


// 活动相关API

/**
 * [getEffectiveActivity 获取关联活动]
 * @return {Promise} [description]
 */
export const getEffectiveActivity = async ()=>{
  let url = `/web/activity/effective/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getEffectiveActivity");
    // data = e;
  }
  return data;
}

/**
 * [getActivityDetail 获取活动详情]
 * @param  {[type]}  id [活动ID]
 * @return {Promise}    [description]
 */
export const getActivityDetail = async ({
  id
})=>{
  let url = `/web/activity/${id}`;
  // let params = {
  //   id
  // }
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getActivityDetail");
    // data = e;
  }
  return data;
}


// 任务相关API

/**
 * [getExclusiveTasks 获取在线未过期的专属自己的任务列表]
 * @return {Promise} [description]
 */
export const getExclusiveTasks = async ()=>{
  let url = `/web/task/exclusive/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getExclusiveTasks");
    // data = e;
  }
  return data;
}

/**
 * 获取我的任务中我的任务活动
 * @param {Number} pageNum 页码
 * @param {Number} pageSize 每次请求的数据量
 */
export const getMyActivities = async ({
	pageNum,
	pageSize
})=>{
	let url = `/api/activity/my/page`;
	let params = {
		pageNum,
		pageSize
	};
	let data = {};
	try{
		data = await _axios.get({url, params})||{};
	}
	catch(e){
		console.error(e,"getMyActivities");
		// data = e;
	}
	return data;
}

/**
 * [getAllMyTask 获取我的任务中所有的任务 有关联的无关联的 不分页]
 * @return {Promise} [description]
 */
export const getAllMyTask = async ()=>{
  let url = `/web/task/useful/list`;
  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getAllMyTask");
    // data = e;
  }
  return data;
}

/**
 * [getTaskDetailById 根据ID获取我的任务中每条任务的详情]
 * @param  {[type]}  id [description]
 * @return {Promise}    [description]
 */
export const getTaskDetailById = async ({
  id
})=>{
  let url = `/web/task/${id}`;

  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getTaskDetailById");
    // data = e;
  }
  return data;
}


// 线索相关接口

/**
 * [createClue 创建线索]
 * @param  {[type]}  param [相应参数]
 * @return {Promise}       [description]
 */
export const createClue = async ({
  ...param
})=>{
  let url = `/web/clue`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"createClue");
    // data = e;
  }
  return data;
}

/**
 * [updateClue 更新线索]
 * @param  {[type]}  param [相应参数]
 * @return {Promise}       [description]
 */
export const updateClue = async ({
  ...param
})=>{
  let url = `/web/clue`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.put({url, params})||{};
  }
  catch(e){
    console.error(e,"updateClue");
    // data = e;
  }
  return data;
}

/**
 * [getClueByPage 分页获取我的线索]
 * @param  {[type]}  customId    [用户ID]
 * @param  {[type]}  pageNum     [页码]
 * @param  {[type]}  pageSize    [每次请求的数据]
 * @param  {[type]}  auditStatus [审核状态] AUDIT_WAIT AUDIT_REJECT AUDIT_PASS AUDIT_ACCEPT
 * @return {Promise}             [description]
 */
export const getClueByPage = async ({
  customId,
  pageNum,
  pageSize,
  auditStatus
})=>{
  let url = `/web/clue/page`;
  let params = {
    customId,
    pageNum,
    pageSize
  }
  if(auditStatus){
    params["auditStatus"] = auditStatus;
  }
  let data = {};
  try{
    data = await _axios.get({url, params})||{};
  }
  catch(e){
    console.error(e,"getClueByPage");
    // data = e;
  }
  return data;
}

/**
 * [getClueDetailById 获取线索详情]
 * @param  {[type]}  id [线索ID]
 * @return {Promise}    [description]
 */
export const getClueDetailById = async ({
  id
})=>{
  let url = `/web/clue/detail`;
  let params = {
    id
  }
  let data = {};
  try{
    data = await _axios.get({url, params})||{};
  }
  catch(e){
    console.error(e,"getClueDetailById");
    // data = e;
  }
  return data;
}


// 用户账户相关接口

/**
 * [correctUserAvatar 设置用户头像]
 * @param  {[type]}  customId [用户ID]
 * @param  {[type]}  fileId   [上传的文件ID]
 * @return {Promise}          [description]
 */
export const correctUserAvatar = async ({
  customId,
	fileId
})=>{
  let url = `/api/user/avatar`;
	let params = {
		customId,
		fileId
	};

	let data = {};
	try{
		data = await _axios.put({url, params})||{};
	}
	catch(e){
		console.error(e,"correctUserAvatar");
		// data = e;
	}
	return data;
}

/**
 * 用户设置昵称
 * @param {string} customId 用户ID
 * @param {string}  nickName 昵称
 */
export const userSetNickName = async ({
	customId,
	nickName
})=>{
	let url = `/api/user/nickName`;
	let params = {
		customId,
		nickName
	};

	let data = {};
	try{
		data = await _axios.put({url, params})||{};
	}
	catch(e){
		console.error(e,"userSetNickName");
		// data = e;
	}
	return data;
}

/**
 * 设置用户姓名
 * @param {string}  customId 用户ID
 * @param {string}  realName 用户姓名
 */
export const userSetRealName = async ({
	customId,
	realName
})=>{
	let url = `/api/user/realName`;
	let params = {
		customId,
		realName
	};

	let data = {};
	try{
		data = await _axios.put({url, params})||{};
	}
	catch(e){
		console.error(e,"userSetRealName");
		// data = e;
	}
	return data;
}

/**
 * 用户设置简介
 * @param {string} customId 用户ID
 * @param {intro}  intro 简介内容
 */
export const userSetIntro = async ({
	customId,
	intro
})=>{
	let url = `/api/user/intro`;
	let params = {
		customId,
		intro
	};

	let data = {};
	try{
		data = await _axios.put({url, params})||{};
	}
	catch(e){
		console.error(e,"userSetIntro");
		// data = e;
	}
	return data;
}


/**
 * [userResetPassword 用户重置密码]
 * @param  {[type]}  email    [邮箱]
 * @param  {[type]}  code     [验证码]
 * @param  {[type]}  password [密码]
 * @return {Promise}          [description]
 */
export const userResetPassword = async ({
	email,
	code,
	password
})=>{
	let url = `/web/custom/password/reset`;
	let params = {
    email,
  	code,
  	password
	};
	let data = {};
	try{
		data = await _axios.post({url, params})||{};
	}
	catch(e){
		console.error(e,"userResetPassword");
		data = e;
	}
	return data;
}

/**
 * [getMailVerifyCode 根据邮箱获取验证阿妈]
 * @param  {[type]} mail [邮箱内容]
 * @return {[type]}      [description]
 */
export const getNoLoginVerifyCode = async ({
  mail
})=>{
  let url = `/web/verification-code/mail`;
  let params = {
    mail
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"getNoLoginVerifyCode");
    data = e;
  }
  // console.log("data====",data);
  return data;
}


/**
 * [customerCertify 用户申请认证]
 * @param  {[type]}  param [description]
 * @return {Promise}       [description]
 */
export const customerCertify = async ({
  ...param
})=>{
  let url = `/web/custom/certification`;
  let params = {
    ...param
  }
  let data = {};
  try{
    data = await _axios.post({url, params})||{};
  }
  catch(e){
    console.error(e,"customerCertify");
    data = e;
  }
  // console.log("data====",data);
  return data;
}

/**
 * 用户使用谷歌账号登录
 * @param {String} openId = [value] 谷歌返回的openId
 * @param {String} email = [value]  谷歌返回的email
 * @param {String} nickName = [value] 谷歌返回的昵称
 * @param {String} avatarUrl = [value] 谷歌返回的头像
 */
export const userLoginByGoogle = async ({
	openId,
	email,
	nickName,
	avatarUrl
})=>{
	let url = `/api/account/google/login`;
	let params = {
		openId,
		email
	};
	if(nickName){
		params["nickName"] = nickName;
	}
	if(avatarUrl){
		params["avatarUrl"] = avatarUrl;
	}

	let data = {};
	try{
		data = await _axios.post({url, params})||{};
	}
	catch(e){
		console.error(e,"userLoginByGoogle");
		// data = e;
	}
	return data;
}


// 获取AWS S3的临时token
export const getAWSS3Token = async ()=>{
  let url = `/web/s3/sts-token`;

  let data = {};
  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getAWSS3Token");
    // data = e;
  }
  return data;
}


// 上传视频到AWS S3 获取视频封面图
export const getAWSS3VideoThumbnail = async ({
  key
})=>{
  let url = `/manager/s3/bucket/${key}/videoFrame`;
  let data = {};

  try{
    data = await _axios.get({url})||{};
  }
  catch(e){
    console.error(e,"getAWSS3VideoThumbnail");
    // data = e;
  }
  return data;
}
